// extracted by mini-css-extract-plugin
export default {"profileCard":"ProfileCard_profileCard__-zIe8","avatar":"ProfileCard_avatar__pknu+","username":"ProfileCard_username__soeW4"};